// extracted by mini-css-extract-plugin
module.exports = {"date":"_d1ef924","dateContent":"_cc5c44a"};